import React from 'react';
import type { TApprovalErrorType } from '../../../types/timesheet';

interface ErrorPageProps {
    errorType: TApprovalErrorType;
    message?: string;
    onRetry?: () => void;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ errorType, message, onRetry }) => {
    const getErrorContent = () => {
        switch (errorType) {
            case 'invalid':
                return {
                    title: 'Invalid Link',
                    description:
                        'This approval link is invalid. Please check your email for the correct link or contact support.',
                };
            case 'expired':
                return {
                    title: 'Link Expired',
                    description:
                        'This approval link has expired. Please check your email for a newer link.',
                };
            case 'network':
                return {
                    title: 'Connection Error',
                    description:
                        'Unable to connect to the server. Please try again later.',
                };
            default:
                return {
                    title: 'Something Went Wrong',
                    description:
                        message || 'An unexpected error occurred. Please try again or contact support.',
                };
        }
    };

    const content = getErrorContent();

    return (
        <div className="timesheet-approval-error">
            <div className="error-container">
                <h1 className="error-title">{content.title}</h1>
                <p className="error-description">{content.description}</p>

                {errorType === 'network' && onRetry && (
                    <button type="button" className="table-action-button" onClick={onRetry}>
                        Try Again
                    </button>
                )}
            </div>
        </div>
    );
};

export default ErrorPage;